module.exports = __webpack_public_path__ + "static/media/menu-admin-icon.54679130.svg";